import fetch from '@/common/fetch';
import { apiName } from '@/api/index';

const path = `${apiName}/enduser`;

// 公告
const viewnoticeurl = `${path}/viewnotice`;
// 发送信息
const sendchaturl = `${path}/sendchat`;
// 聊天记录
const viewchaturl = `${path}/viewchat`;
// 平台服务
const staffserviceurl = `${path}/staffservice`;


const getviewnotice = data => (fetch({
  url: viewnoticeurl,
  method: 'post',
  data,
}));
const sendchat = data => (fetch({
  url: sendchaturl,
  method: 'post',
  data,
}));
const getViewchat = data => (fetch({
  url: viewchaturl,
  method: 'post',
  data,
}));
const getStaffservice = data => (fetch({
  url: staffserviceurl,
  method: 'post',
  data,
}));

export default {
  getviewnotice,
  sendchat,
  getViewchat,
  getStaffservice,
};



// WEBPACK FOOTER //
// ./src/api/enduser/index.js